const Expiry = (pdfName) => {
  if (!pdfName || typeof pdfName !== "string") {
    return { desiredDate: "N/A", expiredProduct: false };
  }

  // Updated regex to capture DD.MM.-DD.MM.YYYY formats, Bulgarian month names, and older templates
  let dateRegex =
    /(\d{1,2}[.-]\d{1,2}(?:[.-]\d{4})?|\d{1,2}\s+(?:ян|фев|мар|апр|май|юн|юли|авг|сеп|окт|ное|дек)(?:\s+\d{4})?|\d{8})/gi;

  let matches = pdfName.match(dateRegex);
  let desiredDate =
    matches && matches.length > 0 ? matches[matches.length - 1] : null;

  let newDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format

  // Format the desiredDate to YYYY-MM-DD
  let formattedDesiredDate = desiredDate
    ? desiredDate.includes("-") || desiredDate.includes(".")
      ? desiredDate
          .replace(/[.-]/g, "-") // Replace dots and dashes with hyphens
          .split("-")
          .reverse()
          .join("-") // Convert DD-MM-YYYY to YYYY-MM-DD
      : desiredDate
          .split(/\s+/)
          .reverse()
          .join("-")
          .replace(
            /(ян|фев|мар|апр|май|юн|юли|авг|сеп|окт|ное|дек)/,
            (month) => {
              switch (month) {
                case "ян":
                  return "01";
                case "фев":
                  return "02";
                case "мар":
                  return "03";
                case "апр":
                  return "04";
                case "май":
                  return "05";
                case "юн":
                  return "06";
                case "юли":
                  return "07";
                case "авг":
                  return "08";
                case "сеп":
                  return "09";
                case "окт":
                  return "10";
                case "ное":
                  return "11";
                case "дек":
                  return "12";
                default:
                  return month;
              }
            }
          )
    : null;

  // Check if the product is expired
  let expiredProduct = formattedDesiredDate
    ? new Date(formattedDesiredDate) < new Date(newDate) // Check if desiredDate is earlier than newDate
    : false;

  return { desiredDate, expiredProduct };
};

export default Expiry;
